// extracted by mini-css-extract-plugin
export default {"container":"FallbackIndicator_container__D--jg"};